import React, { createContext, useState, useMemo, useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { createUnifiedTheme } from 'theme'; //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx//

// 1. Create the context that our components will use to communicate.
const AppThemeContext = createContext({
    // Provide a default empty function to prevent errors if a component
    // tries to use the context without a provider.
    setThemeState: () => {},
});

// 2. Create the Provider component. You will wrap your entire application with this.
export const AppThemeProvider = ({ children }) => {
    // This is the state that holds the current theme settings.
    // The application will start in 'preLogin' mode by default.
    const [themeState, setThemeState] = useState({
        mode: 'preLogin',
        colorMode: 'light',
        customization: {
            fontFamily: "'Roboto', sans-serif",
            borderRadius: 12,
            navType: 'light',
        },
    });

    // We call our master theme factory here, passing in the current state.
    // `useMemo` is a performance optimization: the theme is only recreated if `themeState` changes.
    const theme = useMemo(() => createUnifiedTheme(themeState), [themeState]);

    return (
        // This provider makes the `setThemeState` function available to any child component.
        <AppThemeContext.Provider value={{ setThemeState }}>
            {/* This provider from MUI makes the actual theme object available to all child components. */}
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </AppThemeContext.Provider>
    );
};

// 3. Create a custom hook. This is a shortcut to make it easy to use our context.
export const useAppTheme = () => useContext(AppThemeContext);